import type { RoutePoint } from '../types'

export type MarkerKind = 'start' | 'end' | 'waypoint'

// [lat, lng] tuples for the Leaflet polyline / fitBounds.
export function toPositions(route: RoutePoint[]): [number, number][] {
  return route.map((p) => [p.lat, p.long])
}

// The first point is the start, the last the end, the rest heading waypoints.
// A single-point route is just a start.
export function markerKind(index: number, length: number): MarkerKind {
  if (index === 0) return 'start'
  if (index === length - 1) return 'end'
  return 'waypoint'
}
